export const validateImage = (object) => {
    let file;
    if (object.originFileObj) {
        file = object.originFileObj;
    } else {
        file = object;
    }
    if (!file) {
        return false;
    }
    const MAX_UPLOAD_SIZE = 5_242_880; // in bytes
    return file.size <= MAX_UPLOAD_SIZE;
};
